export default __webpack_public_path__ + "static/media/linseed.21023d48.png";